import { render, staticRenderFns } from "./SerialPage.vue?vue&type=template&id=cbeafde6&scoped=true"
import script from "./SerialPage.vue?vue&type=script&lang=js"
export * from "./SerialPage.vue?vue&type=script&lang=js"
import style0 from "./SerialPage.vue?vue&type=style&index=0&id=cbeafde6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbeafde6",
  null
  
)

export default component.exports